export const ALERT_COMMON_STRINGS = {
    titleError: 'components.alert.title_error',

    buttonOk: 'components.alert.button_ok',
    buttonConfirm: 'components.alert.button_confirm'
};
